(() => {
  const DISCOUNT_CODE = 'PUMP5PACK-X7K92';
  const MIN_SYRUPS = 5;
  const PUMP_HANDLE = '10ml-syrup-pump';

  const root = window.Shopify?.routes?.root || '/';
  const originalFetch = window.fetch.bind(window);

  let syncing = false;

  function isSyrup(item) {
    return (
      item.handle !== PUMP_HANDLE &&
      /syrup/i.test(item.product_title || '')
    );
  }

  function getDiscountCodes(cart) {
    const codes = new Set();

    (cart.cart_level_discount_applications || []).forEach(discount => {
      if (discount.type === 'discount_code' && discount.title) {
        codes.add(discount.title);
      }
    });

    (cart.items || []).forEach(item => {
      (item.line_level_discount_allocations || []).forEach(allocation => {
        const discount = allocation.discount_application;

        if (
          discount &&
          discount.type === 'discount_code' &&
          discount.title
        ) {
          codes.add(discount.title);
        }
      });
    });

    return [...codes];
  }

  async function syncPumpDiscount() {
    if (syncing) return;

    syncing = true;

    try {
      const cartResponse = await originalFetch(root + 'cart.js');
      const cart = await cartResponse.json();

      const syrupQuantity = cart.items
        .filter(isSyrup)
        .reduce((total, item) => total + item.quantity, 0);

      const hasPump = cart.items.some(
        item => item.handle === PUMP_HANDLE && item.quantity > 0
      );

      const shouldApply =
        syrupQuantity >= MIN_SYRUPS && hasPump;

      let codes = getDiscountCodes(cart);

      const currentlyApplied = codes.some(
        code => code.toUpperCase() === DISCOUNT_CODE.toUpperCase()
      );

      if (shouldApply === currentlyApplied) {
        return;
      }

      codes = codes.filter(
        code => code.toUpperCase() !== DISCOUNT_CODE.toUpperCase()
      );

      if (shouldApply) {
        codes.push(DISCOUNT_CODE);
      }

      await originalFetch(root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          discount: codes.join(',')
        })
      });

      window.location.reload();

    } catch (error) {
      console.error('Pump pack discount error:', error);
    } finally {
      syncing = false;
    }
  }

  window.fetch = async function (...args) {
    const response = await originalFetch(...args);

    try {
      const request = args[0];

      const url =
        typeof request === 'string'
          ? request
          : request?.url || '';

      if (
        !syncing &&
        /\/cart\/(add|change|update|clear)(\.js)?/.test(url)
      ) {
        setTimeout(syncPumpDiscount, 150);
      }
    } catch (error) {}

    return response;
  };

  // Check existing cart when page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncPumpDiscount);
  } else {
    syncPumpDiscount();
  }
})();